
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";

export function isAvailable(accountSettings) {
    if (isFeatureEnabled(new Feature(22, []))) {
        return accountSettings.TelematicsEnabled;
    }
    else {
        return false;
    }
}

